import { Moment } from 'moment';
import { Subscription } from 'rxjs';

import { AlertVariant } from '@glu/alerts-react';

import { ApiResponseType, IDropdownOption } from 'common.types';

import { ACCOUNT_MANAGEMENT_GRID_ACTIONS, CHECKFREE_ALERT_VARIANTS } from './checkfree.constants';

// Generic types
export enum WorkflowModeEnum {
  ADD = 'add',
  VERIFY = 'verify',
  MODIFY = 'modify',
  NONE = 'none'
}

export interface ICheckFreeRouteParams {
  module?: string;
  workflowMode?: WorkflowModeEnum;
  userCode?: string;
}

/* Account Management types */
export interface IPremierAccount {
  accountId: number;
  accountNumber: string;
  accountName: string;
  description?: string;
  accountNickName?: string;
}

export type PremierAccountsListType = ApiResponseType<Array<IPremierAccount>>;

export interface IAddAccountFormData {
  bankAccount?: Array<IDropdownOption>;
  isBillPayFeeAccount: boolean;
}

export interface ICheckFreeAccount {
  accountNumber: string;
  accountName: string;
  billingAccount: boolean;
  status: string;
}

export type AccountManagementEnabledResponseType = ApiResponseType<{
  accountManagementEnabled: boolean;
}>;

export type AccountsResponseType = ApiResponseType<{
  checkfreeBankAccount: Array<ICheckFreeAccount>;
}>;

export type BillingAccountEnabledResponseType = ApiResponseType<{
  billingAccountEnabled: boolean;
}>;

export type AcctMgmtGridActionArgsType = {
  action:
    | ACCOUNT_MANAGEMENT_GRID_ACTIONS
    | keyof typeof ACCOUNT_MANAGEMENT_GRID_ACTIONS
    | undefined;
  accountId: number | undefined;
  openModal: boolean;
};
/* Account Management types */
export interface ICheckfreeUser {
  userCode: string;
  authorizationLevel: string;
  firstName: string;
  middleName: string;
  lastName: string;
  status: string;
  addedDate: string;
  dateOfBirth: string;
  taxId: string;
  lastMaintainedDate: string;
}

export interface IPremierUser {
  admin: boolean;
  email: string;
  firstName: string;
  lastName: string;
  middleName: string;
  phone: string;
  prefix: string;
  userCode: string;
}

export interface IUserFormData {
  userAccount: Array<IPremierUser & IDropdownOption>;
  authorizationLevel: Array<IDropdownOption>;
  dateOfBirth: Array<Moment>;
  taxId: string;
}

export interface IAccountManagementSubscriptions {
  modifyBillPayFeeAccountSubscription: Subscription | null;
  deactivateAccountSubscription: Subscription | null;
}

export type variantKeys = keyof typeof CHECKFREE_ALERT_VARIANTS;

export type AlertMapType = {
  [key in variantKeys]?: {
    alertVariant: AlertVariant;
    alertMessage: string;
    dataQa: string;
  };
};
